// src/components/ContentSection.js

import React from 'react';

function ContentSection({ imageClass, title, text, children }) {
  return (
    <section className={imageClass}>
      <div className="content">
        <div className="text-background">
          <h1 class>{title}</h1>
          <p>{text}</p>
          {children && <div className="custom-content">{children}</div>}
        </div>
      </div>
    </section>
  );
}

export default ContentSection;
